document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('modal-show')) {
      e.preventDefault();
      const targetId = e.target.dataset.targetId; 
      document.getElementById(targetId)?.classList.add('show');
    }

    if (e.target.classList.contains('modal-close') || e.target.classList.contains('modal-overlay')) {
      const modal = e.target.closest('.modal') || e.target;
      modal.classList.remove('show');
    }
  });
});
